import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {QueryParamsApiModel} from "../models/query-params-api.model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {ResultListApiModel} from "../models/result-list.api.model";
import {ChatMessageApiModel} from "../models/chat-message.api.model";

export interface CreateMessagePayload {
  content?: string;
  conversation?: string;
  recipient?: string;
  listing?: string;
  attachments?: string[];
  messageType?: string;
  shareType?: string;
  shareId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessageRestService {
  private readonly resource: string = '/messages';

  constructor(
    private http: HttpClient,
    private params: QueryParamsService
  ) {
  }

  public create(payload: CreateMessagePayload): Observable<ChatMessageApiModel> {
    return this.http.post<ChatMessageApiModel>(environment.apiUrl + this.resource, payload)
      .pipe(map(result => plainToClass(ChatMessageApiModel, result)));
  }

  public getCollection(
    queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel(),
    headers?: HttpHeaders
  ): Observable<ResultListApiModel<ChatMessageApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ChatMessageApiModel>>(environment.apiUrl + this.resource, {params, headers})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ChatMessageApiModel>(ChatMessageApiModel), result as object)));
  }
}
